export const HIDDEN_VESTING_LIST = [
  "G7zkBvLxf8rbdqgYmodoQr6wfmSdDD4VzofuEDx5CJV8",
  "8kEcfdkC2gK8wxei2GhEvM7cMPyAPtd68GkNMdLJPwZA",
];
